import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon } from '@maui/elements'
import { isValidFlagIconCode } from './countryCodes'

export const DEFAULT_CONTEXT = { path: '/flags' }
export const FlagIconContext = React.createContext(DEFAULT_CONTEXT)

const ImgIcon = styled.div`
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  position: relative;
  display: inline-block;
  width: 1.33333333em;
  line-height: 1em;
  
  &::before {
    content: '\\00a0';
  }

  ${({ square }) => square && 'width: 1em;'}

  ${({ code, path, square }) => `
    background-image: url(${`${path}/${square ? '1x1' : '4x3'}/${code}.svg`});
  `}
`

const FlagIcon = props => {
  const { path } = useContext(FlagIconContext) || DEFAULT_CONTEXT

  const {
    className,
    code,
    fallback = false,
    square = false,
    ...restProps
  } = props

  if (isValidFlagIconCode(code)) {
    return (
      <div className={className} {...restProps}>
        <ImgIcon
          path={path}
          code={code.toLowerCase()}
          square={square}
        />
      </div>
    )
  }

  if (fallback) {
    return (
      <div className={className} {...restProps}>
        <Icon name='globe' />
      </div>
    )
  }

  return null
}

FlagIcon.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string,
  square: PropTypes.bool,
  fallback: PropTypes.bool,
}

export default styled(FlagIcon)`
  display: inline;
  ${({ theme }) => `color: ${theme.mainTextColor};`}
`
